export const insuredLeadTypes = [
  { key: '1', value: 'BOP', text: 'NowCerts BOP' },
  { key: '2', value: 'CAUTO', text: 'NowCerts CAUTO' },
  { key: '3', value: 'CPKGE', text: 'NowCerts CPKGE' },
  { key: '4', value: 'GHealth', text: 'NowCerts GHealth' },
  { key: '5', value: 'HOME', text: 'NowCerts HOME' },
  { key: '6', value: 'LIFE', text: 'NowCerts LIFE' },
  { key: '7', value: 'PAuto', text: 'NowCerts PAuto' },
  { key: '8', value: 'PLIAB', text: 'NowCerts PLIAB' },
];

export const truckingCompanyProspectTypes = [
  { key: '1', value: 0, text: 'Hot Prospect' },
  { key: '2', value: 1, text: 'Prospect' },
  { key: '3', value: 2, text: 'Cold Prospect' },
];

export const insuredsTypeOpts = [
  { key: '0', value: 0, text: 'Commercial' },
  { key: '1', value: 1, text: 'Personal' },
  { key: '2', value: 2, text: 'LifeHealth Group' },
  { key: '3', value: 3, text: 'LifeHealth Individual' },
  { key: '4', value: 4, text: 'Medicare' },
];

export const truckingCompanyTypeOfBusiness = [
  { key: '0', value: 0, text: 'Corporation' },
  { key: '1', value: 1, text: 'Individual' },
  { key: '2', value: 2, text: 'Joint Venture' },
  { key: '3', value: 3, text: 'LLC' },
  { key: '4', value: 4, text: 'Not For Profit Org' },
  { key: '5', value: 5, text: 'Partnership' },
  { key: '6', value: 6, text: 'Subchapter "S" Corporation' },
  { key: '7', value: 7, text: 'Trust' },
  { key: '8', value: 8, text: 'Other' },
];

export const hasUserAccountOpts = [
  { key: '1', value: 1, text: 'Yes - Invitation' },
  { key: '2', value: 2, text: 'Yes - Activated' },
  { key: '3', value: 0, text: 'No' },
];

export const activeOpts = [
  { key: '1', value: 1, text: 'Yes' },
  { key: '2', value: 0, text: 'No' },
];

export const billingTypeOpts = [
  { key: '1', value: 0, text: 'Direct Bill 100' },
  { key: '2', value: 1, text: 'Direct Bill with agency down payment' },
  { key: '3', value: 2, text: 'Agency Bill 100' },
  { key: '4', value: 3, text: 'Agency Bill with Outside Financing' },
  { key: '5', value: 4, text: 'Agency Bill Paid In Full' },
  { key: '6', value: 5, text: 'Direct Bill Autopay' },
];

export const businessTypeOpts = [
  { key: '0', value: 0, text: 'New Business' },
  { key: '1', value: 1, text: 'Renewal' },
  { key: '2', value: 2, text: 'Rewrite' },
];

export const businessSubTypeOpts = [
  { key: '0', value: 0, text: 'Agent of Record' },
  { key: '1', value: 1, text: 'New Customer' },
  { key: '2', value: 2, text: 'New LOB' },
  { key: '3', value: 3, text: 'Changed Plan' },
  { key: '4', value: 4, text: 'New to Medicare' },
  { key: '5', value: 5, text: 'Purchased Book' },
];

export const autoRenewOpts = [
  { key: '1', value: 1, text: 'Yes' },
  { key: '2', value: 0, text: 'No' },
];

export const serviceRequestStatusOpts = [
  { key: '0_New', value: 0, text: 'New' },
  { key: '1_In_Progress', value: 2, text: 'In Progress' },
  { key: '2_Completed', value: 1, text: 'Completed' },
];
